<script lang="ts">
  interface Props {
    label: string;
    color?: 'gray' | 'blue' | 'indigo' | 'red' | 'green' | 'orange' | 'yellow' | 'solidRed';
    testId?: string;
    class?: string;
    title?: string;
  }

  let { class: klass, label, testId = '', color = 'gray', title = label }: Props = $props();

  const badgeClasses = 'inline-flex items-center px-3 py-1 rounded-full font-medium';

  function getColorClasses(color: string) {
    if (color === 'blue') {
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200';
    } else if (color === 'indigo') {
      return 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-200';
    } else if (color === 'red') {
      return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200';
    } else if (color === 'orange') {
      return 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200';
    } else if (color === 'yellow') {
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200';
    } else if (color === 'solidRed') {
      return 'bg-red-600 text-white dark:bg-red-600 dark:text-white';
    } else if (color === 'green') {
      return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
    } else {
      return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200';
    }
  }
</script>

<span class="{badgeClasses} {getColorClasses(color)} {klass}" data-testid={testId} {title}>
  {label}
</span>
